import { render, staticRenderFns } from "./SideMenuExpandLink.vue?vue&type=template&id=745ab603&scoped=true&"
import script from "./SideMenuExpandLink.vue?vue&type=script&lang=ts&"
export * from "./SideMenuExpandLink.vue?vue&type=script&lang=ts&"
import style0 from "./SideMenuExpandLink.vue?vue&type=style&index=0&id=745ab603&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745ab603",
  null
  
)

export default component.exports